<template>
  <div class="relative">
    <input
      ref="input"
      type="text"
      class="form-input w-full"
      :class="{
        'rounded-b-none rounded-r-none border-b-0 border-r-0 sm:rounded-b sm:border-b': open,
        'placeholder-black': !active && (modelValue || hiddenValue),
      }"
      maxlength="50"
      :placeholder="placeholder"
      :required="required && !(modelValue || hiddenValue)"
      v-model="filter"
      @keydown.enter="addSelected"
      @keydown.down.prevent="moveSelection(1)"
      @keydown.up.prevent="moveSelection(-1)"
      @focus="activate"
      @keydown.esc.prevent="(event) => event.target.blur()"
      @blur="deactivate"
    />
    <div
      ref="results"
      class="border-grey-lighter absolute left-0 right-0 mb-20 flex flex-col overflow-hidden rounded border border-t-0 bg-white py-1 shadow-md"
      v-if="active"
    >
      <button
        type="button"
        :class="roleClasses(index)"
        @mousedown.prevent
        @click="addRole(id)"
        @mouseover="selectedIndex = index"
        v-for="({ name, id }, index) in filtered"
        :key="id"
        v-if="showResults"
      >
        {{ name }}
      </button>
      <div class="px-2 py-1 text-sm text-gray-500" v-if="showResults && !filtered.length">
        {{ this.$t('global.no_role_results') }}
      </div>
      <div class="px-2 py-1 text-sm text-gray-500" v-if="showSearchExplanation">
        {{ this.$t('global.role_search_explanation') }}
      </div>
    </div>
    <input type="hidden" :name="name" :value="hiddenValue" v-if="name" />
  </div>
</template>

<script>
import { nextTick } from 'vue'
export default {
  props: {
    name: { required: false },
    modelValue: { default: null },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    open: { type: Boolean, default: true },
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedIndex: 0,
      filter: '',
      active: false,
      hiddenValue: null,
    }
  },
  computed: {
    filtered() {
      return this.options.filter(
        ({ name }) => name.toLowerCase().indexOf(this.trimmedFilter.toLowerCase()) >= 0
      )
    },
    showSearchExplanation() {
      return this.active && this.trimmedFilter === ''
    },
    showResults() {
      return this.active && this.trimmedFilter !== ''
    },
    trimmedFilter() {
      return this.filter.trim()
    },
    placeholder() {
      if (!this.active && (this.modelValue || this.hiddenValue)) {
        return this.options.filter(({ id }) => id === (this.modelValue || this.hiddenValue))[0].name
      }

      return this.$t('global.pick_a_role')
    },
  },
  methods: {
    activate() {
      this.active = true
    },
    deactivate() {
      this.active = false
      this.filter = ''
    },
    addRole(role) {
      if (!this.active || this.trimmedFilter === '') {
        return
      }

      this.filter = this.filtered[this.selectedIndex].name
      this.selectedIndex = 0

      nextTick(() => {
        this.$refs.input.blur()
      })

      this.$emit('update:modelValue', role)
      this.hiddenValue = role
    },
    roleClasses(index) {
      return (
        'outline-none text-left px-3 py-1 my-1 cursor-pointer max-w-full break-words' +
        (index == this.selectedIndex ? ' bg-brand-500 text-white' : '')
      )
    },
    addSelected(event) {
      if (this.trimmedFilter !== '') {
        event.preventDefault()
      }

      if (!this.showResults) {
        return
      }

      this.addRole(this.filtered[this.selectedIndex].id)
    },
    moveSelection(by) {
      this.selectedIndex = (this.selectedIndex + by) % (this.filtered.length + 1)
      if (this.selectedIndex < 0) {
        this.selectedIndex = this.filtered.length - 1
      }
    },
  },
  watch: {
    modelValue() {
      if (!this.modelValue) {
        this.filter = ''
      }
    },
    filter() {
      let results = this.$refs.results
      if (results === undefined) {
        return
      }

      if (this.showResults) {
        nextTick(() => {
          results.scrollIntoView({
            block: 'nearest',
          })
        })
      }
    },
  },
  emits: ['update:modelValue'],
}
</script>
